var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "upcoming-event" }, [
    _vm.eventTime
      ? _c("div", { staticClass: "upcoming-event-time" }, [
          _vm._v("\n    " + _vm._s(_vm.eventTime) + "\n  "),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "upcoming-event-title" }, [
      _vm._v(_vm._s(_vm.event.eventTitle)),
    ]),
    _vm._v(" "),
    _vm.event.eventImage
      ? _c("div", { staticClass: "upcoming-event-image" }, [
          _c(
            "picture",
            {
              directives: [
                {
                  name: "lazyload",
                  rawName: "v-lazyload",
                  value: {
                    src: _vm.event.eventImage,
                    variant: "upcoming-events",
                  },
                  expression:
                    "{ src: event.eventImage,\n                variant: 'upcoming-events' }",
                },
              ],
              key: _vm.event.eventId + "-image",
              staticClass: "image-wrapper",
            },
            [
              _c("img", {
                staticClass: "image",
                attrs: {
                  src: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
                  alt: _vm.event.eventImageAlt,
                },
              }),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "upcoming-event-content" }, [
      _c("div", { staticClass: "upcoming-event-type" }, [
        _vm.eventType
          ? _c("div", { staticClass: "label" }, [_vm._v(_vm._s(_vm.eventType))])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "time" }, [_vm._v(_vm._s(_vm.eventTime))]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "upcoming-event-title" }, [
        _vm._v(_vm._s(_vm.event.eventTitle)),
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "upcoming-event-description",
        domProps: { innerHTML: _vm._s(_vm.formattedDescription.text) },
      }),
      _vm._v(" "),
      _vm.formattedDescription.isTruncated
        ? _c(
            "a",
            {
              class: [
                "toggle-button",
                "button",
                _vm.showFullDescription ? "less" : "more",
              ],
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.toggleDescriptionVisibility($event)
                },
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.showFullDescription
                      ? _vm.dictionary["upcoming-events:see-less"]
                      : _vm.dictionary["upcoming-events:see-more"]
                  ) +
                  "\n    "
              ),
            ]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "upcoming-event-actions" }, [
      _vm.event.secondaryCtaUrl
        ? _c(
            "a",
            {
              staticClass: "upcoming-event-cta-secondary",
              attrs: {
                href: _vm.event.secondaryCtaUrl,
                target: _vm.event.secondaryCtaTarget,
              },
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.event.secondaryCtaLabel) + "\n    "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.event.primaryCtaUrl
        ? _c(
            "a",
            {
              staticClass: "upcoming-event-cta-primary",
              attrs: {
                href: _vm.event.primaryCtaUrl,
                target: _vm.event.primaryCtaTarget,
              },
            },
            [_vm._v("\n      " + _vm._s(_vm.event.primaryCtaLabel) + "\n    ")]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }